require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-disposable-41.json") })
        }
      }, "path---photos-disposable-41");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-disposable-41!./.cache/json/photos-disposable-41.json
// module id = 442
// module chunks = 231608221292675